import { Component, OnInit,AfterViewInit ,OnDestroy,ViewChild} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from '../servicio-fechas-query.service'
import {ModalDataUsuarioComponent } from '../modal-data-usuario/modal-data-usuario.component'
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {ServiDataUnidadNegocioServiceService}from '../servi-data-unidad-negocio-service.service'
import {ModalAccionesEmpresaComponent } from '../modal-acciones-empresa/modal-acciones-empresa.component'
import { ExcelServiceService } from '../excel-service.service';
import {ServiDataRegionalService} from '../servi-data-regional.service'

@Component({
  selector: 'app-componente-data5',
  templateUrl: './componente-data5.component.html',
  styleUrls: ['./componente-data5.component.scss']
})
export class ComponenteData5Component implements OnInit {

  statuslimpio=true
  arraydelocaciones=[];
  botondisabled=true
  cuenca=''
  locacion=''
  alertaActiva=false
  mensajeAlerta='';
  tipodeAlerta='';
  unidadDeNegocioSeleccionada=''

  todalacuenca=false
  dataset=[]
  dataChart1
  dataChart2
  dataChart3
  dataChart4
  

  constructor(private modalService: NgbModal, public servicioFechasQueryService:ServicioFechasQueryService,public serviDataUnidadNegocioServiceService:ServiDataUnidadNegocioServiceService,private excelServiceService:ExcelServiceService, private serviDataregionalService:ServiDataRegionalService) { }

  ngOnInit(): void {
   
  }

  nuevoReporte(){
    this.serviDataregionalService.dataChart1=this.serviDataregionalService.dataChart1Default
    this.serviDataregionalService.dataChart2=this.serviDataregionalService.dataChart2Default
    this.serviDataregionalService.dataChart3=this.serviDataregionalService.dataChart3Default
    this.serviDataregionalService.dataChart4=this.serviDataregionalService.dataChart4Default
    this.serviDataregionalService.cuencaseleccionada=''
    this.serviDataregionalService.locacionSelecccionada=''
    this.arraydelocaciones=[];
    this.cuenca=''
    this.locacion=''
    this.dataset=[]
    this.statuslimpio=true
  }

  cargaLocaciones(seleccion){
    this.serviDataregionalService.cuencaseleccionada=seleccion
    this.arraydelocaciones=[];
    let query1 = firebase.firestore().collection("locaciones").where("regional","==",seleccion);
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydelocaciones.push(doc);
      })
    })
  }





  generarReporte(){
    this.alertaActiva=true
    this.statuslimpio=false;
    this.serviDataUnidadNegocioServiceService.queryChart1((respuestadataChart1,respuestaChart2,respuestaChart3, respuestaChart4)=>{
      this.dataChart1 = respuestadataChart1
      this.dataChart2 = respuestaChart2
      this.dataChart3 = respuestaChart3
      this.dataChart4 = respuestaChart4
      this.alertaActiva=false

      console.log(this.dataChart1)

    })
  }
  



  seleccionaLocacion(seleccion){
    this.serviDataUnidadNegocioServiceService.unidadDeNegocioSeleccionada = seleccion
  }

  seleccionatodalacuenca(event){
    this.serviDataregionalService.todalacuenca=this.todalacuenca
  }


alerta(tipo,input){
  this.alertaActiva=true;
  this.mensajeAlerta=input;
  this.tipodeAlerta=tipo;
}



closeAlert(){
  this.alertaActiva=false
}



arrayDataset=[]

customScript(){
  let arrayresultados=[]

  let  fechaquerymin = this.servicioFechasQueryService.fechaquerymin
  let  fechaquerymax = this.servicioFechasQueryService.fechaquerymax
  let  query:any  

    query = firebase.firestore().collection("ptws").where("fechainicio", ">=", fechaquerymin).where("fechainicio", "<=", fechaquerymax).where("cuenca","==",this.cuenca);
     
  
    query.get().then((docs)=>{
      docs.forEach((doc)=>{
        arrayresultados.push(doc.data())

       // console.log(doc.data().fechainicio+"|"+doc.data().fechafinal+"|"+doc.data().pozoSeleccionado+"|"+doc.data().empresa+"|"+ this.retornaEmpleados(doc.data().arrayDeEmpleados) +"|"+doc.data().descripcionPTW+"|"+doc.data().ticket+"|"+ doc.data().arrayActividadesPTW  )
      })
    }).catch((err)=>{
      console.log(err);
    }).then(()=>{
      this.procesaData(arrayresultados);
    })
 }


procesaData(arrayresultados){
  let salidavisible=[]
  
  
  arrayresultados.forEach((element,index) => {
    let desgloseEmpleados=""
    let desgloseActividades=""
    let desgloseRevalidaciones=''
    let gerentedecampo=""
    let timestampAprobacion=''

    element.arrayDeEmpleados.forEach((empleado) => {
      desgloseEmpleados += empleado.nombre+"-"+"id:"+empleado.id+" | "
    });

    element.arrayActividadesPTW.forEach((actividad) => {
      desgloseActividades += actividad.actividad +" - "
    });

    if(element.revalidaciones!=undefined){
      element.revalidaciones.forEach((revalidacion) => {
        desgloseRevalidaciones += revalidacion.fecha +"-"+revalidacion.comentario+" | "
      });
    }

    if(element.revalidaciones!=undefined){
      gerentedecampo=element.gerenteCampo.email
    }

    console.log(element.timestampAprobacion)
    if(element.timestampAprobacion!=undefined){
      const jsDate = element.timestampAprobacion.toDate();
      const formattedDate = jsDate.toLocaleString('en-US', {timeZone: 'America/Bogota'});// Format the date using the Internationalization API with the Colombia timezone
      timestampAprobacion = formattedDate
    }
    
    

    salidavisible.push(
      {
        ticket:element.ticket,
        
        cuenca:element.cuenca,
        locacion:element.pozoSeleccionado,
        unidadDeNegocio:element.unidadDeNegocio,
        descripcionPTW:element.descripcionPTW,
        empresa:element.empresa,
        nombreSolicitante:element.nombreSolicitante,
        solicitante:element.solicitante,
        empleados:desgloseEmpleados,
        ActividadesPTW:desgloseActividades,
        autoridadAislante:element.autoridadAislante,
        autoridadArea:element.autoridadArea,
        autoridadAreaLocal:element.autoridadAreaLocal,
        autoridadElectrica:element.autoridadElectrica,
        autoridadHSE:element.autoridadHSE,
        gerenteCampo:gerentedecampo,
        dictamenAutAislante:element.dictamenAutAislante.comentario,
        vistobuenoAutAislante:element.dictamenAutAislante.vistobueno,
        dictamenAutArea:element.dictamenAutArea.comentario,
        vistobuenoAutArea:element.dictamenAutArea.vistobueno,
        dictamenAutAreaLocal:element.dictamenAutAreaLocal.comentario,
        vistobuenoAutAreaLocal:element.dictamenAutAreaLocal.vistobueno,
        dictamenAutElectrica:element.dictamenAutElectrica.comentario,
        vistobuenoAutElectrica:element.dictamenAutElectrica.vistobueno,
        dictamenAutHSE:element.dictamenAutHSE.comentario,
        vistobuenoAutHSE:element.dictamenAutHSE.vistobueno,
        observaciones:element.observaciones,
        enviado:element.enviado,
        fechasolicitud:element.fechasolicitud,
        fechaUltimaEdicion:element.fechaUltimaEdicion,
        fechainicio:element.fechainicio,
        fechafinal:element.fechafinal,
        horarioDeTrabajo:element.horarioDeTrabajo,
        timestampAprobacion:timestampAprobacion,
        revalidaciones:desgloseRevalidaciones,
        status:element.status

      }

    )


    if(index == arrayresultados.length -1 ){
      console.log(salidavisible)
      this.excelServiceService.generaexcel(salidavisible);
    }

 

  });
}


 retornaEmpleados(array){
  let salida = ""
  array.forEach((element, index) => {
    salida = salida+element.nombre+" - "
    if(index == array.length-1){
      return salida
    }
  });
 }




}//fin de clase
